import React from 'react'
import styled from 'styled-components'
import cx from 'classnames'

import './ui.scss'

const Icon = ({ className, component: Component, ...props }) => {
  const classes = cx(className, 'm-icon')

  return (
    <Component className={classes} {...props} />
  )
}

export default styled(Icon)``
